import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth.service';
import {Observable} from 'rxjs/Observable';
import {AppConstants} from './app.constants';

@Injectable()
export class Awss3UploadService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  generateSignedUrl(body): Observable<any> {
    const url = environment.apiBase + 's3/sign';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  generatePublicUrl(url: string, body: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Content-Type', body.type);
    headers.set('x-amz-acl', 'public-read');
    return this.http.put(url, body, {headers: headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shared/awss3-upload.service.ts